/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.sdr.js
Source: slb_src/slices/sdr/
Build: slb_build/build_sdr.mjs
Built: 2026-09-19 16:53:53.404Z
Content-SHA256: 4ce4c29d303b83a5ff21451b9dea7dabe0f6bd4a4c6162da0ee1aa39094faaf0
Content-SHA256-12: 4ce4c29d303b
*/

/* ====== SLB SDR SRC: 00_sdr.js ====== */
// Source for assets/slb.sdr.js (generated). Edit this file, then run slb_build/build_slb.bat.
(function(){
  'use strict';
  if(window.__SLB_SDR_BOOT__) return;
  window.__SLB_SDR_BOOT__ = true;

function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function nl2br(s){ return esc(s).replace(/\n/g,'<br>'); }

  function stripHtmlText_(html){
    try{
      var d = new DOMParser().parseFromString(String(html||''), 'text/html');
      return (d.body && (d.body.innerText || d.body.textContent) || '').replace(/\s+$/,'').trim();
    }catch(_e){ return String(html||'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim(); }
  }

  function sanitizeRichHtml_(html){
    html = String(html||'');
    if(!html) return '';
    try{
      var doc = new DOMParser().parseFromString('<div>'+html+'</div>', 'text/html');
      var root = doc.body.firstChild;
      var allowTags = {
        DIV:1,P:1,BR:1,B:1,STRONG:1,I:1,EM:1,U:1,S:1,DEL:1,UL:1,OL:1,LI:1,
        A:1,IMG:1,H1:1,H2:1,H3:1,H4:1,BLOCKQUOTE:1,SPAN:1,PRE:1,CODE:1
      };
      function cleanStyle(st){
        st = String(st||'');
        if(!st) return '';
        var keep = {};
        st.split(';').forEach(function(part){
          var kv = part.split(':');
          if(kv.length<2) return;
          var k = kv[0].trim().toLowerCase();
          var v = kv.slice(1).join(':').trim();
          if(!k || !v) return;
          if(k==='color' || k==='background-color' || k==='font-size' || k==='text-align' || k==='font-weight' || k==='font-style' || k==='text-decoration' || k==='white-space'){
            keep[k]=v;
          }
        });
        return Object.keys(keep).map(k=>k+':'+keep[k]).join(';');
      }
      function walk(node){
        if(!node) return;
        // remove scripts/styles
        if(node.nodeType===1){
          var tag = node.tagName;
          if(tag==='SCRIPT' || tag==='STYLE' || tag==='IFRAME' || tag==='OBJECT' || tag==='EMBED'){
            node.parentNode && node.parentNode.removeChild(node);
            return;
          }
          if(!allowTags[tag]){
            // unwrap
            var parent = node.parentNode;
            if(parent){
              while(node.firstChild) parent.insertBefore(node.firstChild, node);
              parent.removeChild(node);
              return;
            }
          }else{
            // clean attrs
            Array.from(node.attributes||[]).forEach(function(a){
              var name = a.name.toLowerCase();
              if(name.startsWith('on')) node.removeAttribute(a.name);
              if(name==='style'){
                var s = cleanStyle(node.getAttribute('style'));
                if(s) node.setAttribute('style', s); else node.removeAttribute('style');
              }
              if(tag==='A' && name==='href'){
                var href = String(node.getAttribute('href')||'').trim();
                if(href && !/^(https?:|mailto:|#)/i.test(href)) node.removeAttribute('href');
              }
              if(tag!=='A' && name==='href') node.removeAttribute('href');
              if(tag!=='IMG' && (name==='src' || name==='alt')) { if(name==='src') node.removeAttribute('src'); }
            });
          }
        }
        var child = node.firstChild;
        while(child){
          var next = child.nextSibling;
          walk(child);
          child = next;
        }
      }
      walk(root);
      return root.innerHTML || '';
    }catch(_e){
      return html.replace(/<script[\s\S]*?<\/script>/gi,'').replace(/on\w+=/gi,'');
    }
  }

  function rpc(action, args, opts){
    var API = window.SLB_APP;
    if(!API || typeof API.rpc !== 'function') throw new Error('SLB_APP.rpc not ready');
    return API.rpc(action, args||{}, opts||{});
  }

  function getResult(res){
    if(res && typeof res === 'object'){
      if(res.ok === false) throw new Error(res.error || 'Error');
      if(res.result != null) return res.result;
      if(res.ok === true && res.data != null) return res.data;
    }
    return res;
  }

  function getRole(){
    try{
      var S = window.SLB_APP && window.SLB_APP.S;
      var callsign = (S && (S.callsign || (S.role && S.role.callsign))) || (sessionStorage.getItem('tyw_callsign')||'') || '';
      callsign = String(callsign||'').trim().toUpperCase();
      var isAdmin = !!(S && (S.isAdmin || (S.role && S.role.isAdmin)));
      var isModerator = !!(S && (S.isModerator || (S.role && S.role.isModerator)));
      return { callsign: callsign, isAdmin: isAdmin, isModerator: isModerator };
    }catch(_e){
      return { callsign:'', isAdmin:false, isModerator:false };
    }
  }

  function toast(msg){
    try{ if(window.SLB_APP && typeof window.SLB_APP.toast==='function') return window.SLB_APP.toast(msg); }catch(_e){}
    try{ if(!window.SLB_DEBUG) return; console.log('[SDR]', msg); }catch(_e2){}
  }

  function injectStyleOnce(id, cssText){
    if(document.getElementById(id)) return;
    var st = document.createElement('style');
    st.id = id;
    st.textContent = cssText;
    document.head.appendChild(st);
  }

  function pad2_(n){ n = parseInt(n,10); if(isNaN(n)) n=0; return (n<10?'0':'')+n; }
  function fmtYmd_(d){ if(!d) return ''; return d.getFullYear()+'-'+pad2_(d.getMonth()+1)+'-'+pad2_(d.getDate()); }
  function todayDateKey(){ return fmtYmd_(new Date()); }


  // Draft Entry ID (unique per report session)
  let __sdrDraftEntryId = null;

  function genSdrEntryId_(){
    const role = getRole();
    const cs = (role && role.callsign) ? String(role.callsign).trim() : "UNKNOWN";
    const dk = todayDateKey();
    let rid = "";
    try{
      if(window.crypto && window.crypto.randomUUID) rid = window.crypto.randomUUID().replace(/-/g,'');
    }catch(_e){}
    if(!rid){
      rid = (Date.now().toString(36) + Math.random().toString(16).slice(2)).replace(/[^a-z0-9]/gi,'');
    }
    return cs + "-" + dk + "-" + rid.slice(0, 16);
  }

  function newSdrDraftId_(){
    __sdrDraftEntryId = genSdrEntryId_();
    return __sdrDraftEntryId;
  }
  function setSdrDraftId_(id){ __sdrDraftEntryId = String(id||'').trim() || null; }

  function getSdrDraftId_(){
    if(!__sdrDraftEntryId) __sdrDraftEntryId = genSdrEntryId_();
    return __sdrDraftEntryId;
  }


  function toDate_(s){ try{ var d=new Date(s); if(!d||isNaN(d.getTime())) return null; return d; }catch(_e){ return null; } }
  function fmtDateKey_(dk){
    dk = String(dk||'').trim();
    if(!dk) return '';
    if(/^\d{4}-\d{2}-\d{2}$/.test(dk)) return dk;
    var d = toDate_(dk);
    if(d) return fmtYmd_(d);
    var m = dk.match(/(\d{4}-\d{2}-\d{2})/);
    if(m) return m[1];
    return dk.length>10 ? dk.slice(0,10) : dk;
  }
  function timeAgo_(iso){
    var d = toDate_(iso);
    if(!d) return '';
    var ms = Date.now() - d.getTime();
    if(ms<0) ms=0;
    var s = Math.floor(ms/1000);
    if(s<60) return s+'s';
    var m = Math.floor(s/60);
    if(m<60) return m+'m';
    var h = Math.floor(m/60);
    if(h<48) return h+'h';
    var days = Math.floor(h/24);
    if(days<60) return days+'d';
    var mo = Math.floor(days/30);
    if(mo<24) return mo+'mo';
    var y = Math.floor(mo/12);
    return y+'y';
  }

  
  // ===== SDR Tool Embed Loader (no iframe) =====
  // Loads assets/sdr_tool.html into #slbSdrToolHost, with CSS scoped so it won't affect the rest of SLB.
  var SDR_STYLE_ID_ = "slbSdrToolScopedStyle_v1";

  function getSdrToolUrl_(){
    try{
      if(window.SLB_SDR_TOOL_URL) return String(window.SLB_SDR_TOOL_URL);
      var lazy = window.SLB_LAZY_ASSETS || {};
      if(lazy.sdrTool) return String(lazy.sdrTool);
      if(lazy.sdr){
        var u = String(lazy.sdr);
        var base = u.split("?")[0];
        var q = (u.indexOf("?") >= 0) ? u.slice(u.indexOf("?")) : "";
        var slash = base.lastIndexOf("/");
        if(slash >= 0) return base.slice(0, slash+1) + "sdr_tool.html" + q;
      }
    }catch(_e){}
    // fallback (may not work on Shopify CDN paths, but kept as last resort)
    return "/assets/sdr_tool.html";
  }

  function scopeCss_(css, scope){
    if(!css) return "";
    var i = 0, out = "";
    var n = css.length;

    function readUntil(pattern){
      var j = css.indexOf(pattern, i);
      if(j === -1){ var s = css.slice(i); i = n; return s; }
      var s = css.slice(i, j);
      i = j + pattern.length;
      return s;
    }
    function readBlock(){
      // assumes css[i] is after '{'
      var depth = 1;
      var start = i;
      while(i < n){
        var ch = css[i++];
        if(ch === '"' || ch === "'"){
          var q = ch;
          while(i < n){
            var c = css[i++];
            if(c === "\\") { i++; continue; }
            if(c === q) break;
          }
          continue;
        }
        if(ch === "/" && css[i] === "*"){
          i++; readUntil("*/");
          continue;
        }
        if(ch === "{") depth++;
        else if(ch === "}"){
          depth--;
          if(depth === 0){
            return css.slice(start, i-1);
          }
        }
      }
      return css.slice(start);
    }
    function scopeSelectorList(sel){
      var parts = sel.split(",");
      var scoped = parts.map(function(s){
        s = (s || "").trim();
        if(!s) return "";
        // Replace :root / body with scope directly (no extra prefix)
        s = s.replace(/:root\b/g, scope).replace(/\bbody\b/g, scope);
        if(s.indexOf(scope) === 0) return s;
        return scope + " " + s;
      }).filter(Boolean);
      return scoped.join(", ");
    }

    while(i < n){
      if(css[i] === "/" && css[i+1] === "*"){
        out += "/*" + readUntil("*/");
        continue;
      }

      if(css[i] === "@"){
        var header = "";
        while(i < n){
          var ch = css[i++];
          header += ch;
          if(ch === ";") break;
          if(ch === "{") break;
        }
        if(header.trim().endsWith(";")){
          out += header;
          continue;
        }
        var headTrim = header.trim().toLowerCase();
        var inner = readBlock();
        var endBrace = "}";
        if(headTrim.startsWith("@keyframes") || headTrim.startsWith("@-webkit-keyframes") || headTrim.startsWith("@font-face")){
          out += header + inner + endBrace;
        }else{
          out += header + scopeCss_(inner, scope) + endBrace;
        }
        continue;
      }

      var sel = "";
      while(i < n){
        var ch2 = css[i++];
        if(ch2 === "{") break;
        sel += ch2;
      }
      if(i >= n && sel.trim() === ""){
        out += sel;
        break;
      }
      var scopedSel = scopeSelectorList(sel);
      var body = readBlock();
      out += scopedSel + "{" + body + "}";
    }
    return out;
  }

  async function mountSdrToolInto_(host){
    if(!host || (host.dataset && host.dataset.sdrMounted === "1")) return;

    // Mark SDR tool as embedded (disable draft persistence inside the tool)
    try{ window.__SLB_EMBEDDED_SDR_TOOL__ = true; }catch(_e){}
    // Hard reset any legacy stored draft
    try{ localStorage.removeItem("dsdiag_v11_light_simple"); }catch(_e2){}
    if(host.dataset) host.dataset.sdrMounted = "1";

    host.innerHTML = '<div style="padding:10px;color:#6b7680;">Loading SDR tool…</div>';

    var toolUrl = getSdrToolUrl_();
    var htmlText = "";
    try{
      var res = await fetch(toolUrl, { credentials: "same-origin", cache: "no-store" });
      htmlText = await res.text();
    }catch(e){
      host.innerHTML = '<div style="padding:10px;color:#b00020;">Failed to load SDR tool.</div>';
      return;
    }

    var doc = null;
    try{
      doc = new DOMParser().parseFromString(htmlText, "text/html");
    }catch(_e2){
      host.innerHTML = '<div style="padding:10px;color:#b00020;">SDR tool parse failed.</div>';
      return;
    }

    var cssText = "";
    try{
      Array.from(doc.querySelectorAll("style")).forEach(function(st){ cssText += "\n" + (st.textContent || ""); });
    }catch(_e3){}

    var scripts = [];
    try{
      scripts = Array.from(doc.body.querySelectorAll("script"));
      scripts.forEach(function(sc){ sc.parentNode && sc.parentNode.removeChild(sc); });
    }catch(_e4){}

    host.innerHTML = "";
    var frag = document.createDocumentFragment();
    Array.from(doc.body.childNodes).forEach(function(node){
      frag.appendChild(document.importNode(node, true));
    });
    host.appendChild(frag);

    try{
      if(!document.getElementById(SDR_STYLE_ID_)){
        var stEl = document.createElement("style");
        stEl.id = SDR_STYLE_ID_;
        stEl.textContent = scopeCss_(cssText, "#slbSdrToolHost");
        document.head.appendChild(stEl);
      }
    }catch(_e5){}

    try{
      scripts.forEach(function(sc){
        var s = document.createElement("script");
        if(sc.src){
          s.src = sc.src;
        }else{
          s.textContent = sc.textContent || "";
        }
        host.appendChild(s);
      });
    }catch(_e6){}
  }

  // Also expose for other modules / debug (safe)
  window.__SLB_SDR_MOUNT_TOOL__ = mountSdrToolInto_;

// ===== Tool UI (ported from daily_spiritual_diagnosis_click_report_light_v23.html) =====
  

  injectStyleOnce('slbSdrCss', `
    #slbSdrPanel .slbSdrWrap{ max-width:1200px; margin:0 auto; padding:10px 8px 16px; }
    #slbSdrPanel details.slbSdrDetails{ border:1px solid rgba(15,21,23,.12); border-radius:16px; overflow:hidden; margin:10px 0; background:#fff; }
    #slbSdrPanel summary.slbSdrSummary{ list-style:none; display:flex; align-items:center; justify-content:space-between; gap:10px; cursor:pointer; padding:10px 12px; background: var(--ty-grey-ui, rgba(15,21,23,.10)); font-weight:800; color:#0f1517; }
    #slbSdrPanel summary.slbSdrSummary::-webkit-details-marker{ display:none; }
    #slbSdrPanel .slbSdrBody{ padding:12px; }

    #slbSdrPanel .slbSdrOut{ margin-top:12px; }
    #slbSdrPanel .slbSdrBtnRow{ display:flex; justify-content:center; gap:10px; flex-wrap:wrap; margin-bottom:10px; }
    #slbSdrPanel .slbSdrBtnRow .btn{ border-radius:12px; padding:10px 12px; font-size:14px; border:1px solid rgba(15,21,23,.18); background:#fff; cursor:pointer; font-weight:800; }
    #slbSdrPanel .slbSdrBtnRow .btn.primary{ background: var(--ty-orange, #ef5e14); border-color: var(--ty-orange, #ef5e14); color:#fff; }
    #slbSdrPanel .slbSdrBtnRow .btn.danger{ background: rgba(239,94,20,.08); border-color: rgba(239,94,20,.35); color:#0f1517; }
    #slbSdrPanel .slbSdrBtnRow .btn:disabled{ opacity:.55; cursor:not-allowed; }

#slbSdrPanel .slbSdrSaveRow{ margin-top:10px; margin-bottom:0; }
#slbSdrPanel .slbSdrSaveRow .btn{ min-width:120px; }
#slbSdrPanel .slbSdrBtnRow .btn.email{ background:#b42318; border-color:#b42318; color:#fff; }


    #slbSdrPanel .slbSdrFinalText,
    #slbSdrPanel .slbSdrNotesText{
      width:100%;
      min-height:140px;
      resize:vertical;
      border-radius:14px;
      border:1px solid rgba(15,21,23,.14);
      padding:12px;
      font-size:14px;
      line-height:1.4;
      margin-top:10px;
    }
    #slbSdrPanel .slbSdrNotesText{ min-height:90px; }
    #slbSdrPanel .slbSdrOut .slbSdrNotesText{ margin-top:0; }

    #slbSdrPanel .slbSdrTop{ display:flex; align-items:center; gap:10px; flex-wrap:wrap; margin-bottom:10px; }
    #slbSdrPanel .slbSdrTop input{ flex:1; min-width:220px; border-radius:12px; border:1px solid rgba(15,21,23,.18); padding:10px 10px; font-size:14px; }
    #slbSdrPanel .slbSdrTop input:focus{ outline:none; border-color: var(--ty-orange, #ef5e14); box-shadow:0 0 0 4px rgba(239,94,20,.18); }
    #slbSdrPanel .slbSdrTop .btn{ border-radius:12px; padding:10px 12px; border:1px solid rgba(15,21,23,.18); background:#fff; cursor:pointer; font-weight:800; }
    #slbSdrPanel .slbSdrTop .btn.primary{ background: var(--ty-orange, #ef5e14); border-color: var(--ty-orange, #ef5e14); color:#fff; }
    #slbSdrPanel .slbSdrTop .btn.ghost{ background: transparent; }

    #slbSdrPanel .slbSdrGrid{ display:grid; grid-template-columns: 300px 1fr; gap:12px; }
    #slbSdrPanel .slbSdrList{ border:1px solid rgba(15,21,23,.12); border-radius:14px; overflow:hidden; background:#fff; min-height:220px; }
    #slbSdrPanel .slbSdrListHead{ padding:10px 10px; border-bottom:1px solid rgba(15,21,23,.10); background: var(--ty-grey-ui, rgba(15,21,23,.10)); font-weight:800; }
    #slbSdrPanel .slbSdrItem{ display:block; width:100%; text-align:left; padding:10px 10px; border:0; border-bottom:1px solid rgba(15,21,23,.08); background:transparent; cursor:pointer; }
    #slbSdrPanel .slbSdrList .slbSdrItem:nth-of-type(odd){ background: var(--ty-surface-2, #fff3e6); }
    #slbSdrPanel .slbSdrList .slbSdrItem:nth-of-type(even){ background: var(--ty-surface-3, #fff); }
    #slbSdrPanel .slbSdrItem:hover{ background: var(--ty-hover, #ffe5d1); }
    #slbSdrPanel .slbSdrItem.active{ background: var(--ty-active, #ffd4b4); }
    #slbSdrPanel .slbSdrItemTop{ display:flex; align-items:center; justify-content:space-between; gap:10px; }
    #slbSdrPanel .slbSdrItemDate{ font-weight:900; color:#0f1517; }
    #slbSdrPanel .slbSdrItemAge{ font-size:12px; color:#6b7680; }
    #slbSdrPanel .slbSdrItemSnip{ margin-top:4px; font-size:12px; color:#6b7680; }

    #slbSdrPanel .slbSdrViewer{ border:1px solid rgba(15,21,23,.12); border-radius:14px; overflow:hidden; background:#fff; min-height:220px; }
    #slbSdrPanel .slbSdrViewerHead{ padding:10px 10px; border-bottom:1px solid rgba(15,21,23,.10); background: var(--ty-grey-ui, rgba(15,21,23,.10)); display:flex; align-items:center; justify-content:space-between; gap:10px; }
    #slbSdrPanel .slbSdrViewerTitle{ font-weight:900; color:#0f1517; }
    #slbSdrPanel .slbSdrViewerBtns{ display:flex; gap:8px; flex-wrap:wrap; }
    #slbSdrPanel .slbSdrViewerBtns .btn{ border-radius:12px; padding:8px 10px; border:1px solid rgba(15,21,23,.18); background:#fff; cursor:pointer; font-weight:800; font-size:13px; }
    #slbSdrPanel .slbSdrViewerBtns .btn.danger{ background:#b42318; border-color:#b42318; color:#fff; }
    #slbSdrPanel .slbSdrViewerBody{ padding:10px 10px 12px; }
    #slbSdrPanel .slbSdrMeta{ color:#6b7680; font-size:12px; margin-bottom:10px; }
    #slbSdrPanel .slbSdrCard{ border:1px solid rgba(15,21,23,.10); border-radius:12px; padding:10px 10px; margin:10px 0; }
    #slbSdrPanel .slbSdrCard h4{ margin:0 0 6px 0; font-size:13px; color:#0f1517; }
    #slbSdrPanel .slbSdrCard .content{ font-size:13px; color:#0f1517; line-height:1.35; }
    #slbSdrPanel .slbSdrSmall{ font-size:12px; color:#6b7680; }

    /* SDR tool embed tweaks (only when mounted inside SLB) */
    #slbSdrPanel #slbSdrToolHost .spBtn{ min-height:72px !important; padding:18px 0 !important; }
    #slbSdrPanel #slbSdrToolHost .fatBtn{ min-height:106px !important; padding:22px 14px !important; }
    #slbSdrPanel #slbSdrToolHost .fatMain{ color:#0f1517 !important; }
    #slbSdrPanel #slbSdrToolHost .fatSub{ color:#6b7680 !important; }
    #slbSdrPanel #slbSdrToolHost #secReport{ display:none !important; }

    @media (max-width: 860px){
      #slbSdrPanel .slbSdrGrid{ grid-template-columns: 1fr; }
    }
  `);

  

  // ===== Records (User) =====
  var myState = {
    list: null,
    selected: '',
    loading: false
  };

  function snipText(s, max){
    s = String(s||'').replace(/\s+/g,' ').trim();
    if(!s) return '';
    if(max && s.length > max) return s.slice(0,max) + '…';
    return s;
  }

  function setMyViewer(html){
    var root = document.getElementById('slbSdrMyViewer');
    if(root) root.innerHTML = html;
  }

  function renderMyList(filter){
    var box = document.getElementById('slbSdrMyList');
    if(!box) return;
    var items = (myState.list && myState.list.items) ? myState.list.items.slice() : [];

    filter = String(filter||'').trim().toLowerCase();
    if(filter){
      items = items.filter(function(it){
        var dk = fmtDateKey_(it.dateKey||'');
        var sn = snipText(it.body||it.notes||'', 80).toLowerCase();
        return dk.toLowerCase().indexOf(filter) >= 0 || sn.indexOf(filter) >= 0;
      });
    }

    var h = '';
    h += '<div class="slbSdrListHead">SDR Records</div>';
    if(!items.length){
      h += '<div style="padding:12px;" class="slbSdrSmall">No records yet.</div>';
      box.innerHTML = h;
      return;
    }

    items.forEach(function(it){
      var eid = String(it.entryId||it.entryID||it.id||'');
      var dk = fmtDateKey_(it.dateKey||'');
      var age = timeAgo_(it.updatedAt||it.createdAt||'');
      var sn = snipText(it.body||it.notes||'', 80);
      var active = (eid && myState.selected === eid) ? ' active' : '';
      h += '<button type="button" class="slbSdrItem'+active+'" data-eid="'+esc(eid)+'">'
        + '<div class="slbSdrItemTop"><div class="slbSdrItemDate">'+esc(dk||'—')+'</div><div class="slbSdrItemAge">'+esc(age)+'</div></div>'
        + '<div class="slbSdrItemSnip">'+esc(sn||'')+'</div>'
        + '</button>';
    });

    box.innerHTML = h;

    qsa('.slbSdrItem', box).forEach(function(btn){
      btn.addEventListener('click', function(){
        var eid = btn.getAttribute('data-eid') || '';
        if(!eid) return;
        openMyEntry(eid);
      });
    });
  }

  async function loadMyList(force){
    if(myState.loading) return;
    if(!force && myState.list) return;
    myState.loading = true;
    try{
      var res = await rpc('sdrList', { limit: 200 });
      myState.list = getResult(res) || {items:[]};
    }catch(e){
      myState.list = { items: [] };
      toast('SDR list failed.');
    }finally{
      myState.loading = false;
    }
  }

  function buildMyViewerShell(title){
    return '<div class="slbSdrViewerHead">'
      + '<div class="slbSdrViewerTitle">'+esc(title||'SDR Entry')+'</div>'
      + '<div class="slbSdrViewerBtns">'
      + '<button type="button" class="btn" id="slbSdrMyRefreshBtn">Refresh</button>'
      + '</div>'
      + '</div>'
      + '<div class="slbSdrViewerBody"><div class="slbSdrSmall">Select an entry on the left.</div></div>';
  }

  async function openMyEntry(entryId){
    entryId = String(entryId||'').trim();
    if(!entryId) return;
    myState.selected = entryId;

    renderMyList(qs('#slbSdrMySearch') ? qs('#slbSdrMySearch').value : '');
    setMyViewer('<div class="slbSdrViewerHead"><div class="slbSdrViewerTitle">Loading…</div><div class="slbSdrViewerBtns"></div></div><div class="slbSdrViewerBody"><div class="slbSdrSmall">Loading entry…</div></div>');

    var item = null;
    try{
      var res = await rpc('sdrGet', { entryId: entryId, includeRich: true });
      var out = getResult(res) || {};
      item = out.item || out.entry || out.data || null;
    }catch(e){
      item = null;
    }

    if(!item){
      setMyViewer('<div class="slbSdrViewerHead"><div class="slbSdrViewerTitle">SDR Entry</div><div class="slbSdrViewerBtns"><button type="button" class="btn" id="slbSdrMyRefreshBtn">Refresh</button></div></div><div class="slbSdrViewerBody"><div class="slbSdrSmall">Failed to load.</div></div>');
      bindMyViewerBtns();
      return;
    }

    var dk = fmtDateKey_(item.dateKey||'');
    var meta = 'Updated: ' + esc(item.updatedAt||item.createdAt||'') + (item.updatedAt ? (' ('+esc(timeAgo_(item.updatedAt))+')') : '');

    var bodyHtml = item.bodyRich ? String(item.bodyRich) : (item.body ? nl2br(item.body) : '');
    var notesHtml = item.notesRich ? String(item.notesRich) : (item.notes ? nl2br(item.notes) : '');

    var html = '';
    html += '<div class="slbSdrViewerHead">'
      + '<div class="slbSdrViewerTitle">'+esc(dk||'SDR Entry')+'</div>'
      + '<div class="slbSdrViewerBtns">'
      + '<button type="button" class="btn" id="slbSdrMyEditBtn">Edit</button>'
            + '<button type="button" class="btn danger" id="slbSdrMyDeleteBtn">Delete</button>'
      + '<button type="button" class="btn" id="slbSdrMyRefreshBtn">Refresh</button>'
      + '</div>'
      + '</div>';

    html += '<div class="slbSdrViewerBody">'
      + '<div class="slbSdrMeta">'+meta+'</div>'
      + '<div class="slbSdrCard"><h4>Report</h4><div class="content">'+bodyHtml+'</div></div>'
      + (notesHtml ? ('<div class="slbSdrCard"><h4>Notes</h4><div class="content">'+notesHtml+'</div></div>') : '')
      + '</div>';

    setMyViewer(html);
    bindMyViewerBtns(item);
  }

  function bindMyViewerBtns(item){
    var bR = document.getElementById('slbSdrMyRefreshBtn');
    if(bR){
      bR.addEventListener('click', async function(){
        myState.list = null;
        await bootUserRecords(true);
      });
    }

    var bE = document.getElementById('slbSdrMyEditBtn');
    if(bE && item){
      bE.addEventListener('click', function(){
        try{
          // open Diagnose section
          var d1 = document.querySelector('#slbSdrPanel details.slbSdrDetails');
          if(d1) d1.open = true;
        }catch(_e){}
        try{
          // load report into rich editor + notes into textarea
          var repArea = document.getElementById('slbSdrFinalRich');
          var notesBox = document.getElementById('slbSdrNotesText');
          var repHtml = (item.bodyRich && String(item.bodyRich).trim()) ? String(item.bodyRich) : ('<div style="white-space:pre-wrap;">'+nl2br(esc(String(item.body||'')))+'</div>');
          if(repArea) repArea.innerHTML = sanitizeRichHtml_(repHtml);
          if(notesBox){
            if(item.notes) notesBox.value = String(item.notes||'');
            else if(item.notesRich) notesBox.value = stripHtmlText_(String(item.notesRich||''));
            else notesBox.value = '';
          }
          setSdrDraftId_(String(item.entryId||''));
          toast('Loaded into editor.');
          try{ window.scrollTo({ top: 0, behavior: 'smooth' }); }catch(_e2){ window.scrollTo(0,0); }
        }catch(_e3){
          toast('Edit load failed.');
        }
      });
    }

    var bD = document.getElementById('slbSdrMyDeleteBtn');
    if(bD && item){
      bD.addEventListener('click', async function(){
        if(!confirm('Delete this SDR entry?')) return;
        bD.disabled = true;
        try{
          await rpc('sdrDelete', { entryId: String(item.entryId||'') });
          toast('Deleted.');
          myState.selected = '';
          myState.list = null;
          await bootUserRecords(true);
        }catch(e){
          toast('Delete failed.');
        }finally{
          bD.disabled = false;
        }
      });
    }
  }

  async function bootUserRecords(force){
    await loadMyList(!!force);
    renderMyList(qs('#slbSdrMySearch') ? qs('#slbSdrMySearch').value : '');

    if(!myState.selected){
      var items = (myState.list && myState.list.items) ? myState.list.items : [];
      if(items && items.length){
        var eid = String(items[0].entryId||items[0].entryID||items[0].id||'');
        if(eid) openMyEntry(eid);
        else setMyViewer(buildMyViewerShell('SDR Entry'));
      }else{
        setMyViewer(buildMyViewerShell('SDR Entry'));
      }
    }
  }

  // ===== Submit bridge for tool =====
  // Pull report text from the embedded SDR tool via postMessage
  function getReportFromTool(timeoutMs, notesOverride){
    timeoutMs = timeoutMs || 1200;
    return new Promise(function(resolve, reject){
      var done = false;
      var to = setTimeout(function(){
        if(done) return;
        done = true;
        window.removeEventListener('message', onMsg);
        reject(new Error('timeout'));
      }, timeoutMs);

      function onMsg(ev){
        try{
          if(!ev || !ev.data) return;
          if(ev.data.type !== 'SDR_REPORT') return;
          var txt = String(ev.data.text || '');
          if(done) return;
          done = true;
          clearTimeout(to);
          window.removeEventListener('message', onMsg);
          resolve(txt);
        }catch(_e){}
      }

      window.addEventListener('message', onMsg);
      try{ window.postMessage({ type:'SDR_GET_REPORT', notes: (notesOverride||'') }, '*'); }catch(e){}

    });
  }

  function extractDateKeyFromReport(reportText){
    var m = /\bDate\s*:\s*(\d{4}-\d{2}-\d{2})\b/.exec(String(reportText||''));
    if(m && m[1]) return m[1];
    return '';
  }

  async function submitReport(payload){
    payload = payload || {};
    var role = getRole();
    if(!role.callsign) throw new Error('login');

    var dk = String(payload.dateKey||'').trim();
    var notesText = String(payload.notesText||'');
    var entryId = String(payload.entryId || getSdrDraftId_() || '').trim();

    // Rich editor -> HTML + plain text
    var repArea = qs('#slbSdrFinalRich');
    var reportHtml = repArea ? sanitizeRichHtml_(repArea.innerHTML || '') : '';
    var reportText = String(payload.reportText || '').trim();
    if(!reportText){
      reportText = repArea ? (String(repArea.innerText || repArea.textContent || '').trim()) : '';
    }

    var notesHtml = notesText ? ('<div>' + nl2br(esc(notesText)) + '</div>') : '';

    if(!dk){
      dk = extractDateKeyFromReport(reportText) || todayDateKey();
    }

    await rpc('sdrUpsert', {
      dateKey: dk,
      entryId: entryId,
      body: reportText,
      bodyRich: reportHtml,
      notes: notesText,
      notesRich: notesHtml
    });

    // refresh records
    myState.list = null;
    myState.selected = '';
    await bootUserRecords(true);
  }

  // Expose bridge for tool
  window.SLB_SDR = window.SLB_SDR || {};
  window.SLB_SDR.submitReport = submitReport;

  async function bootUser(){
    var root = document.getElementById('slbSdrPanel');
    if(!root) return;

    if(root.dataset && root.dataset.slbBooted === '1'){
      // ensure list refresh works after tab switch
      try{ if(qs('#tysdrMount', root)) return; }catch(_e){}
    }

    var role = getRole();
    if(!role.callsign){
      root.innerHTML = '<div style="padding:14px;">Loading profile...</div>';
      var __tries = 0;
      (function retry(){
        __tries++;
        var r = getRole();
        if(r && r.callsign){ setTimeout(bootUser, 0); return; }
        if(__tries > 20){ root.innerHTML = '<div style="padding:14px;">Please login first.</div>'; return; }
        setTimeout(retry, 250);
      })();
      return;
    }

    if(root.dataset) root.dataset.slbBooted = '1';

    root.innerHTML = `
      <div class="slbSdrWrap">
        <details class="slbSdrDetails" open>
          <summary class="slbSdrSummary">
            <div>Diagnose</div>
            
          </summary>
          <div class="slbSdrBody">
            <div id="slbSdrToolHost"></div>

            <div class="slbSdrOut">
              <textarea id="slbSdrNotesText" class="slbSdrNotesText" placeholder="Notes (optional)"></textarea>

              <div class="slbSdrBtnRow">
                <button type="button" class="btn primary" id="slbSdrFinalize">Finalize</button>
                <button type="button" class="btn danger" id="slbSdrClear">Clear</button>
              </div>
              <div class="slbStdEditor" data-slbeditor="v1" id="slbSdrStdEditor" data-slbeditor-height="360">
                <div class="slbWysToolbar slbStdToolbar">
                  <div class="slbWysRow">
                    <div class="slbWysGroup">
                      <select class="inp" data-wys-heading style="width:160px;">
                        <option value="p">Paragraph</option>
                        <option value="h1">H1</option>
                        <option value="h2">H2</option>
                        <option value="h3">H3</option>
                        <option value="h4">H4</option>
                      </select>
                      <select class="inp" data-wys-size style="width:110px;">
                        <option value="12">12</option>
                        <option value="14" selected>14</option>
                        <option value="16">16</option>
                        <option value="18">18</option>
                        <option value="20">20</option>
                        <option value="24">24</option>
                        <option value="28">28</option>
                        <option value="32">32</option>
                        <option value="40">40</option>
                      </select>
                    </div>

                    <div class="slbWysGroup">
                      <button class="btn soft mini" type="button" data-wcmd="bold"><b>B</b></button>
                      <button class="btn soft mini" type="button" data-wcmd="italic"><i>I</i></button>
                      <button class="btn soft mini" type="button" data-wcmd="underline"><u>U</u></button>
                      <button class="btn soft mini" type="button" data-wcmd="strikeThrough"><s>S</s></button>
                    </div>

                    <div class="slbWysGroup">
                      <button class="btn soft mini" type="button" data-wcmd="insertUnorderedList" title="Bullet list">•</button>
                      <button class="btn soft mini" type="button" data-wcmd="insertOrderedList" title="Number list">1.</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyLeft" title="Align left">⟸</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyCenter" title="Align center">⇔</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyRight" title="Align right">⟹</button>
                      <button class="btn soft mini" type="button" data-wcmd="justifyFull" title="Justify">☰</button>
                      <button class="btn soft mini" type="button" data-wcmd="quote" title="Quote">❝</button>
                    </div>
                  </div>

                  <div class="slbWysRow">
                    <div class="slbWysGroup">
                      <button class="btn square mini" type="button" data-wcolor="#ef4444" style="background:#ef4444;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#f59e0b" style="background:#f59e0b;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#10b981" style="background:#10b981;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#3b82f6" style="background:#3b82f6;color:#fff;">A</button>
                      <button class="btn square mini" type="button" data-wcolor="#7c3aed" style="background:#7c3aed;color:#fff;">A</button>
                      <input type="color" class="inp" data-wys-colorpicker style="width:36px;padding:0;" />
                    </div>

                    <div class="slbWysGroup">
                      <button class="btn square mini" type="button" data-wbg="#fde68a" style="background:#fde68a;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#bbf7d0" style="background:#bbf7d0;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#bfdbfe" style="background:#bfdbfe;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#fecaca" style="background:#fecaca;color:#000;">HL</button>
                      <button class="btn square mini" type="button" data-wbg="#f3e8ff" style="background:#f3e8ff;color:#000;">HL</button>
                      <input type="color" class="inp" data-wys-hlpicker style="width:36px;padding:0;" />
                    </div>

                    <div class="slbWysGroup slbEmojiWrap">
                      <button class="btn soft mini" type="button" data-wcmd="emoji" title="Emojis">🙂</button>
                      <div class="slbEmojiPanel hidden">
                        <button class="slbEmojiItem" type="button" data-emoji="😀">😀</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😁">😁</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😄">😄</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😂">😂</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🤣">🤣</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🙂">🙂</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😉">😉</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😎">😎</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🤔">🤔</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😮">😮</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😭">😭</button>
                        <button class="slbEmojiItem" type="button" data-emoji="😡">😡</button>
                        <button class="slbEmojiItem" type="button" data-emoji="👍">👍</button>
                        <button class="slbEmojiItem" type="button" data-emoji="👎">👎</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🙏">🙏</button>
                        <button class="slbEmojiItem" type="button" data-emoji="✨">✨</button>
                        <button class="slbEmojiItem" type="button" data-emoji="⚡">⚡</button>
                        <button class="slbEmojiItem" type="button" data-emoji="❤️">❤️</button>
                        <button class="slbEmojiItem" type="button" data-emoji="💜">💜</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🔥">🔥</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🌙">🌙</button>
                        <button class="slbEmojiItem" type="button" data-emoji="⭐">⭐</button>
                        <button class="slbEmojiItem" type="button" data-emoji="✅">✅</button>
                        <button class="slbEmojiItem" type="button" data-emoji="❗">❗</button>
                        <button class="slbEmojiItem" type="button" data-emoji="💡">💡</button>
                        <button class="slbEmojiItem" type="button" data-emoji="📌">📌</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🧧">🧧</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🐉">🐉</button>
                        <button class="slbEmojiItem" type="button" data-emoji="☯️">☯️</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🌀">🌀</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🛡️">🛡️</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🎯">🎯</button>
                        <button class="slbEmojiItem" type="button" data-emoji="📣">📣</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🤝">🤝</button>
                        <button class="slbEmojiItem" type="button" data-emoji="🟠">🟠</button>
                        <button class="slbEmojiItem" type="button" data-emoji="⚔️">⚔️</button>
                      </div>
                    </div>

                    <div class="slbWysGroup slbWysEnd">
                      <button class="btn soft mini" type="button" data-wcmd="createLink" title="Link">🔗</button>
                      <button class="btn soft mini" type="button" data-wcmd="insertImage" title="Image">🖼️</button>
                      <button class="btn soft mini" type="button" data-wcmd="yt" title="YouTube">▶️</button>
                      <button class="btn soft mini square" type="button" data-wcmd="removeFormat" title="Clear formatting">✕</button>
                    </div>
                  </div>
                </div>

                <div class="richEditor slbStdArea" data-slbeditor-area contenteditable="true" spellcheck="true" id="slbSdrFinalRich"></div>
              </div>
<div class="slbSdrBtnRow slbSdrSaveRow">
                <button type="button" class="btn primary" id="slbSdrSave">SAVE</button>
                <button type="button" class="btn email" id="slbSdrEmailJee">&gt;&gt; Si Juen</button>
              </div>
            </div>
          </div>
        </details>

        <details class="slbSdrDetails" open>
          <summary class="slbSdrSummary">
            <div>Records</div>
            
          </summary>
          <div class="slbSdrBody">
            <div class="slbSdrTop">
              <input id="slbSdrMySearch" type="text" placeholder="Search date or text..." />
              <button class="btn" id="slbSdrMyRefresh" type="button">Refresh</button>
            </div>

            <div class="slbSdrGrid">
              <div class="slbSdrList" id="slbSdrMyList"></div>
              <div class="slbSdrViewer" id="slbSdrMyViewer"></div>
            </div>
          </div>
        </details>
      </div>
    `;

    try{
      var __host = qs('#slbSdrToolHost', root);
      if(__host) mountSdrToolInto_(__host);
      // New report session on every entry
      newSdrDraftId_();
      try{ window.postMessage({ type:"SDR_CLEAR" }, "*"); }catch(_e2){}
      try{ setTimeout(()=>{ try{ window.postMessage({ type:"SDR_CLEAR" }, "*"); }catch(_e3){} }, 200); }catch(_e4){}
    }catch(_e){}
// Wire finalize/clear/save/email controls
var tFinal = qs('#slbSdrFinalRich', root);
var edRoot = qs('#slbSdrStdEditor', root);
try{ if(edRoot && window.SLB_STD_EDITOR_V1 && window.SLB_STD_EDITOR_V1.bind) window.SLB_STD_EDITOR_V1.bind(edRoot); }catch(_e){}
var tNotes = qs('#slbSdrNotesText', root);
var bFin = qs('#slbSdrFinalize', root);
var bClear = qs('#slbSdrClear', root);
var bSave = qs('#slbSdrSave', root);
var bEmail = qs('#slbSdrEmailJee', root);

if(bFin){
  bFin.addEventListener('click', async function(){
    bFin.disabled = true;
    try{
      var txt2 = await getReportFromTool(2000, (tNotes && tNotes.value) ? String(tNotes.value) : '');
      if(tFinal){ var _t = String(txt2||'').trim(); tFinal.innerHTML = sanitizeRichHtml_('<div style="white-space:pre-wrap;">'+nl2br(esc(_t))+'</div>'); }
      toast('Finalized.');
    }catch(_e){
      toast('Could not finalize (no report yet).');
    }finally{
      bFin.disabled = false;
    }
  });
}

if(bClear){
  bClear.addEventListener('click', function(){
    try{ window.postMessage({ type:'SDR_CLEAR' }, '*'); }catch(_e){}
    if(tFinal) tFinal.innerHTML = '';
    if(tNotes) tNotes.value = '';
    newSdrDraftId_();
    toast('Cleared.');
  });
}

if(bSave){
  bSave.addEventListener('click', async function(){
    bSave.disabled = true;
    try{
      var reportHtmlNow = tFinal ? sanitizeRichHtml_(tFinal.innerHTML || '') : '';
      var report = reportHtmlNow ? stripHtmlText_(reportHtmlNow) : '';
      if(!report){
        try{
          report = await getReportFromTool(2000, (tNotes && tNotes.value) ? String(tNotes.value) : "");
          if(tFinal){ var _t2 = String(report||'').trim(); tFinal.innerHTML = sanitizeRichHtml_('<div style="white-space:pre-wrap;">'+nl2br(esc(_t2))+'</div>'); }
        }catch(_e){
          toast('No report to save.');
          return;
        }
      }
      report = String(report||'').trim();
      if(!report){ toast('No report to save.'); return; }

      var dateKey = extractDateKeyFromReport(report) || todayDateKey();
      var notes = (tNotes && tNotes.value) ? String(tNotes.value) : '';
      toast('Saving...');
      await submitReport({ dateKey: dateKey, reportText: report, notesText: notes, entryId: getSdrDraftId_() });
      toast('Saved.');
    }catch(_e){
      toast('Save failed.');
    }finally{
      bSave.disabled = false;
    }
  });
}

if(bEmail){
  bEmail.addEventListener('click', async function(){
    bEmail.disabled = true;
    try{
      var report2Html = tFinal ? sanitizeRichHtml_(tFinal.innerHTML || '') : '';
      var report2 = report2Html ? stripHtmlText_(report2Html) : '';
      if(!report2){
        try{
          report2 = await getReportFromTool(2000, (tNotes && tNotes.value) ? String(tNotes.value) : "");
          if(tFinal){ var _t3 = String(report2||'').trim(); tFinal.innerHTML = sanitizeRichHtml_('<div style="white-space:pre-wrap;">'+nl2br(esc(_t3))+'</div>'); }
        }catch(_e){
          toast('No report to email.');
          return;
        }
      }
      report2 = String(report2||'').trim();
      if(!report2){ toast('No report to email.'); return; }

      var dk2 = extractDateKeyFromReport(report2) || todayDateKey();
      var notes2 = (tNotes && tNotes.value) ? String(tNotes.value) : '';
      toast('Emailing...');
      await rpc('sdrEmailJee', { dateKey: dk2, reportText: report2, notesText: notes2, reportHtml: report2Html, notesHtml: (notes2?('<div>'+nl2br(esc(notes2))+'</div>'):'') });
      toast('Email sent.');
    }catch(_e){
      toast('Email failed.');
    }finally{
      bEmail.disabled = false;
    }
  });
}

// records boot
    setMyViewer(buildMyViewerShell('SDR Entry'));
    await bootUserRecords(false);

    var s = qs('#slbSdrMySearch', root);
    if(s){
      var t=null;
      s.addEventListener('input', function(){ clearTimeout(t); t=setTimeout(function(){ renderMyList(s.value); }, 120); });
    }

    var rbtn = qs('#slbSdrMyRefresh', root);
    if(rbtn){
      rbtn.addEventListener('click', async function(){
        rbtn.disabled = true;
        try{ myState.list=null; myState.selected=''; await bootUserRecords(true); }
        finally{ rbtn.disabled=false; }
      });
    }
  }

  // Boot now and on tab clicks
  try{ bootUser(); }catch(_e){}
  document.addEventListener('click', function(ev){
    var t = ev.target;
    if(!t) return;
    var tab = t.getAttribute && t.getAttribute('data-tab');
    if(tab === 'sdr') setTimeout(bootUser, 0);
  }, true);

})();

